import { Theme } from '../../../config/config.types';
import { TypographyProps, ColorProps } from 'styled-system';

type HTMLElementType = any;

export enum VARIANT {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export enum MODE {
  DISPLAY = 'display',
  TITLE = 'title',
  HEADING = 'heading',
  SUBHEADING = 'subheading',
}

export enum WEIGHT {
  NORMAL = 'normal',
  BOLD = 'bold',
}

export type Weight = 'normal' | 'bold';
export type Mode = 'display' | 'title' | 'heading' | 'subheading';
export type Variant = 'primary' | 'secondary';

export { Theme };
export type StyledProps = TypographyProps & ColorProps & {};

export interface ComponentProps extends HTMLElementType, StyledProps {
  mode?: Mode;
  variant?: Variant;
  weight?: Weight;
}
